import * as React from "react";
import Header from "../Components/Header";
import FormationCard from "../Components/FormationCard";
import BlogService from "../../Service/BlogService";
import { useParams } from "react-router-dom";
import { useState } from "react";
import TrainingService from "../../Service/TrainingService";
import { useEffect } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import pdfUrl from "../Pages/image/2024-Certificat-Qualiopi.pdf"
import pdfImage from "../Pages/image/Capture.PNG"
import { Document, Page } from "@react-pdf/renderer";
import TrainersSlider from "../Components/TrainerSlider";
import MultiAddressMap from "../Components/MultiAddressMap";
import CreateAddress from "../../Controller/CreateAddress";
import { Button, Form } from "react-bootstrap";
import MyLoader from "../Components/Loader";
import ImagePlaceholder from "../Components/ImagePlaceholder";
import { Helmet } from "react-helmet";

function Quisommesnous() {
  const token = sessionStorage.getItem('token');
  const [formateurs, setFormateurs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formationsData, setFormationsData] = useState();
  const [address, setAddress] = useState();
  const [newAddress, setNewAddress] = useState();
  const [createAttempt, setCreateAttempt] = useState(false);

  const handlecreate = (event) => {
    event.preventDefault();

    setCreateAttempt(true);

    return <CreateAddress addresse={newAddress} />;
  };

  useEffect(() => {
    fetchTraining();
  }, [])

  const fetchTraining = async () => {
    try {
      let response = await BlogService.fetchFormateurs();
      setFormateurs(response.data)
      let response2 = await BlogService.fetchAdresses();
      setAddress(response2.data)
    } catch (error) {
      console.log("erreur" + error);
    } finally {
      try {
        let response = await TrainingService.fetchTrainings();
        let incendieList = [];
        response.data.trainings.slice(0, 3).map(training => {
          incendieList.push(training);
        });
        setFormationsData(incendieList);
      } catch (error) {
        console.log("erreur" + error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    }
  }
  return (
    <>
      <Helmet>
        <title>Qui sommes-nous ?</title>
        <meta name="description" content="Page d'information" />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header title={"Qui sommes-nous ?"}></Header>
      <main className="page-qui-sommes-nous-desktop">
        <div className="section">
          <div className="intro">
            <h2 className="section-qui">Qui sommes-nous ?</h2>
            <div className="content">
              <div className="images">
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/6535cacb0e4af52127bbb26ab60b8fff2e6fef373467ce1b6617972cd3e0e0dc?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45"
                  className="img-qui"
                  alt="Image 1"
                />
                <img
                  loading="lazy"
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/625879e6510931911c61dc1d36e73ae52dc5ed58fb458d2aab170014a1ca5b1b?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45"
                  className="img-2"
                  alt="Image 2"
                />
              </div>
              <p className="description-qui">
                <strong>Fondé en février 2017</strong>, SC Formation Prévention Secours est un organisme de formation spécialisé en <strong>secourisme</strong> et <strong>sécurité incendie</strong>.
              </p>
            </div>
            <br />
            <p className="m-auto">
              Notre mission : former les professionnels et les citoyens aux gestes qui sauvent et aux bons réflexes en situation d’urgence. <br />
              Nous proposons des formations certifiantes et opérationnelles, telles que :
              <ul>
                <li><strong>Sauveteur Secouriste du Travail (SST)</strong></li>
                <li><strong>Formateur SST</strong></li>
                <li><strong>Premiers Secours Citoyens (PSC)</strong></li>
                <li><strong>Manipulation d’extincteurs</strong></li>
                <li><strong>Service Sécurité Incendie et d’Assistance aux Personnes (SSIAP)</strong></li>
                <li><strong>Premiers Secours en Santé Mentale (PSSM)</strong>.</li>
              </ul>
              SCFPS est <strong>certifié Qualiopi</strong>, gage de notre engagement qualité et de notre conformité aux exigences de financement.
            </p>
          </div>
          <div className="map-container-2">
            {loading ? (
              ImagePlaceholder()
            ) : (
              <MultiAddressMap addresses={address} />
            )}
          </div>
          {token === '' && (
            <>
              <Form className='text-black' onSubmit={handlecreate}>
                <Form.Group className="mb-3 w-50 m-auto" controlId="formBasicUsername">
                  <Form.Label>Ajouter une nouvelle addresse</Form.Label>
                  <Form.Control
                    className='mb-5'
                    type="text"
                    placeholder="Adresse"
                    onChange={(e) => setNewAddress(e.target.value)}
                    required
                  />
                </Form.Group>
                <div className='text-center mt-5 mb-3'>
                  <Button className='mb-4' size="lg" variant="secondary" type="submit">
                    Ajouter une addresse
                  </Button>
                </div>
              </Form>
              {createAttempt && (
                <CreateAddress addresse={newAddress} />
              )}
            </>
          )}
          <div className="mission-qui">
            <h3 className="mission-title">Nos valeurs</h3>
            <p class="text-center">
              Chez SCFPS, la formation est avant tout une mission d’intérêt humain. Nos valeurs fondatrices :
            </p>
            <div className="mission-section">
              <div className="mission-column">
                <img
                  loading="lazy"
                  srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=800 800w"
                  className="img-3"
                  alt="Quality training image"
                />
                <p>
                  <strong>Transmission </strong>: rendre chacun capable d’agir, de secourir, de prévenir.
                </p>
              </div>

              <div className="mission-column">

                <img
                  loading="lazy"
                  srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=200 200w"
                  className="img-4"
                  alt="Missions image"
                />
                <p>
                  <strong>Exigence </strong>: proposer des contenus fiables, actualisés, alignés sur les référentiels nationaux.
                </p>
              </div>

              <div className="mission-column">
                <img
                  loading="lazy"
                  srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=200 200w"
                  className="img-5"
                  alt="Human training image"
                />
                <p>
                  <strong>Accessibilité </strong>: permettre à tous les publics, y compris en situation de handicap (LSF, …), d’accéder à une formation de qualité.
                </p>
              </div>

              <div className="mission-column">
                <img
                  loading="lazy"
                  srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/bdfd6e320c0352b3389196092880695e45454ebe021e608bc971028ab66a544a?apiKey=59156c16963f46e28d2e0d857e2bfa45&width=200 200w"
                  className="img-5"
                  alt="Human training image"
                />
                <p>
                  <strong>Engagement terrain </strong>: former pour agir concrètement, efficacement et en toute sécurité.
                </p>
              </div>
            </div>
          </div>

          <div className="history-section">
            <h3 className="mission-title">Notre histoire</h3>

          </div>
        </div>
        <div className="timeline-top">
          <div className="timeline-item">
            <div className="timeline-title">Début des formations à la sécurité incendie</div>
            <div className="timeline-year">2018</div>
          </div>

          <div className="timeline-item">
            <div className="timeline-line" />
            <div className="timeline-content">
              <div className="timeline-description">
                Renouvellement habilitations INRS SST niveau 1 et 2 + obtention habilitation INRS Acteur PRAP
              </div>
              <div className="timeline-year">2022</div>
              <div className="timeline-line" />
            </div>
          </div>
          <div className="timeline-item">
            <div className="timeline-line" />
            <div className="timeline-content">
              <div className="timeline-description">
                Agrandissement de nos locaux pour un total de plus de 450 m² (4 salles de formation, 1 plateau technique « incendie », salle de restauration, …)
              </div>
              <div className="timeline-year">2025</div>
              <div className="timeline-line" />
            </div>
          </div>
        </div>

        <div className="timeline-separator">
          <div className="separator-line">
            <div className="separator-point"></div>
            <div className="separator-point"></div>
            <div className="separator-point"></div>
            <div className="separator-point"></div>
            <div className="separator-point"></div>
            <div className="separator-point"></div>
          </div>
        </div>
        <div className="timeline-bottom">
          <div className="timeline-item">
            <div className="timeline-content">
              <div className="timeline-year">2017</div>
              <div className="timeline-description">
                <span style={{ fontWeight: 600 }}>02/2017:</span> Création de la société pour faire de la formation au secourisme
                <br />
                <br />
                <span style={{ fontWeight: 600 }}>12/2017:</span> Obtention habilitation INRS pour les formations « Acteurs SST » (niveau 1) et Formateurs SST (niveau 2) / inscription au Datadock
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-content">
              <div className="timeline-year">2020</div>
              <div className="timeline-description">
                Obtention du certificat QUALIOPI
                <br />
                <br />
                Audit de renouvellement validé en 2024
                <br />
                <a href={pdfUrl} download>
                  <img
                    src={pdfImage}
                    alt="Aperçu du PDF"
                    className="img-fluid"
                    style={{ border: '1px solid #ddd', borderRadius: '5px', cursor: 'pointer' }}
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-content">
              <div className="timeline-year">2024</div>
              <div className="timeline-description">
                <ul>
                  <li>01/2024: Agrément de la Préfecture du Nord pour les formations SSIAP</li>
                  <li>02/2024: Nouvelle formation au catalogue: AFGSU (Attestation de Formation aux Gestes et Soins d’Urgence)</li>
                  <li>06/2024: Nouvelle formation au catalogue: Premiers Secours en Santé Mentale (PSSM)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="div-30">
          {/* <div className="trainers-section">
            <div className="section-header">
              <h2 className="forma-title">Nos formateurs</h2>
              <p>
                Notre équipe est composée de <strong>professionnels expérimentés</strong>, tous certifiés dans leurs domaines d’intervention : pompiers, formateurs en prévention, sauveteurs secouristes, et spécialistes des risques professionnels.
              </p>
              <p>
                Ils partagent une même approche : <strong>pédagogie active, bienveillance et rigueur</strong>, pour garantir des formations impactantes, efficaces et adaptées à vos besoins spécifiques.
              </p>
            </div>
            {loading ? (
              MyLoader()
            ) : (
              <TrainersSlider formateurs={formateurs} token={token} />
            )}
            {token === '' && (
              <a href="/createFormateur">
                <button
                  className="inscription-button modif_button"
                  style={{ marginLeft: '10px' }}
                >
                  Créer un Formateur
                </button></a>
            )}
          </div> */}
          <div className="NosForma">
            <section className="autres-formations">
              <h2 className="mission-title">Notre démarche pédagogique</h2>
              <p>
                Chez SCFPS, nous plaçons <strong>l’expérience terrain et l’efficacité pédagogique</strong> au cœur de nos formations. <br />
                Nos parcours sont conçus pour être <strong>pratiques, participatifs et immersifs</strong>, grâce à :
                <ul>
                  <li>des <strong>mises en situation concrètes</strong>, inspirées des réalités professionnelles,</li>
                  <li>des <strong>exercices dynamiques </strong>et adaptés à chaque secteur d’activité,</li>
                  <li>une <strong>individualisation des apports</strong> selon le profil et les attentes des apprenants.</li>
                </ul>
                Pour aller plus loin, nous intégrons également <strong>des technologies innovantes</strong> telles que la <strong>réalité virtuelle</strong> et la <strong>réalité augmentée</strong>, permettant une immersion totale dans des situations d’urgence simulées. <br />
                Ces outils renforcent l’engagement, la mémorisation et la prise de décision dans un environnement sécurisé. <br />
                Toutes nos formations s’appuient sur les <strong>référentiels officiels (INRS, Ministère, etc.)</strong> et sont régulièrement actualisées pour rester conformes, actuelles, et immédiatement applicables.
              </p>
              <div className="row">
                {loading ? (
                  MyLoader()
                ) : (
                  formationsData.map((formation, index) => (
                    <a href={"/formation/" + formation.id} className="col-md-4 mb-4">
                      <div key={index}>
                        <div className="card ssip3-card">
                          {formation.training_cycle.id === 1 ? (
                            <img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/25af45e77d6bdad6be0823e485e1185dbcade06700e334c8679be0e3beea81f8?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />
                          ) : formation.training_cycle.id === 2 ? (
                            <img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/a0a73d9596425af046d195ca798473528c2f8d418be124f00087b8b935102ee7?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />
                          ) : (<img src={'https://cdn.builder.io/api/v1/image/assets/TEMP/ad826d4b70d96ec1d03af674552d8991a3c18ddf6c062a52ef99778dc6fc8a99?apiKey=59156c16963f46e28d2e0d857e2bfa45&'} alt={formation.name} className="course-image" />)}
                          <div className="card-body text-center">
                            <div className="ssip3-overlay">
                              <h1 className="ssip3-title">{formation.name}</h1>
                            </div>
                            {formation.training_cycle.id === 1 ? (
                              <div className="ssip3-tag">Incendie</div>
                            ) : formation.training_cycle.id === 2 ? (
                              <div className="ssip3-tag-2">Secourisme</div>
                            ) : (<div className="ssip3-tag-3">Prévention des risques</div>)}
                          </div>
                        </div>
                      </div></a>
                  ))
                )}

              </div>
              <a href="#" className="voir-toutes">Voir toutes les formations &gt;</a>
            </section></div>
          {/* <div className="mission-title">
            Nos dernières actualités
          </div>
          <div className="div-54">
            <div className="div-55">
              <div className="column">
                <div className="div-56">
                  <img
                    loading="lazy"
                    srcSet="
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=100 100w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=200 200w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=400 400w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=800 800w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=1200 1200w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=1600 1600w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=2000 2000w
          "
                    className="img"
                  />
                  <div className="formation-details">
                    FORMATION PSE1 DU
                    <br />
                    1ER AU 5 MARS 2021
                    <br />
                    <span style={{ fontWeight: 400, fontSize: "16px" }}>Samedi 6 Mars</span>
                    <br />
                    <br />
                    <span style={{ fontWeight: 400, fontSize: "14px" }}>
                      Voici quelques photos de la formation PSE1 (Premiers Secours en
                      Équipe de niveau 1)
                    </span>
                    <br />
                  </div>
                  <div className="en-savoir-plus">En savoir plus &gt;</div>
                </div>
              </div>
              <div className="column-14">
                <div className="div-57">
                  <img
                    loading="lazy"
                    srcSet="
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=100 100w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=200 200w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=400 400w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=800 800w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=1200 1200w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=1600 1600w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=2000 2000w
          "
                    className="img"
                  />
                  <div className="formation-details">
                    FORMATION PSE1 DU
                    <br />
                    1ER AU 5 MARS 2021
                    <br />
                    <span style={{ fontWeight: 400, fontSize: "16px" }}>Samedi 6 Mars</span>
                    <br />
                    <br />
                    <span style={{ fontWeight: 400, fontSize: "14px" }}>
                      Voici quelques photos de la formation PSE1 (Premiers Secours en
                      Équipe de niveau 1)
                    </span>
                    <br />
                  </div>
                  <div className="en-savoir-plus">En savoir plus &gt;</div>
                </div>
              </div>
              <div className="column-15">
                <div className="div-58">
                  <img
                    loading="lazy"
                    srcSet="
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=100 100w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=200 200w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=400 400w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=800 800w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=1200 1200w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=1600 1600w,
            https://cdn.builder.io/api/v1/image/assets/TEMP/68f25b391f856b7753401c515a9d9266545b222f551f32ab436a475ff854a90e?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=2000 2000w
          "
                    className="img"
                  />
                  <div className="formation-details">
                    FORMATION PSE1 DU
                    <br />
                    1ER AU 5 MARS 2021
                    <br />
                    <span style={{ fontWeight: 400, fontSize: "16px" }}>Samedi 6 Mars</span>
                    <br />
                    <br />
                    <span style={{ fontWeight: 400, fontSize: "14px" }}>
                      Voici quelques photos de la formation PSE1 (Premiers Secours en
                      Équipe de niveau 1)
                    </span>
                    <br />
                  </div>
                  <div className="en-savoir-plus">En savoir plus &gt;</div>
                </div>
              </div>
            </div>
          </div>
          <div className="decouvrir-notre-actualite">
            Découvrir notre actualité
          </div> */}
        </div>
      </main>
    </>
  );
}

export default Quisommesnous;